/* eslint-disable camelcase */
import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { Icon, ICON_NAME, ICON_SIZE } from 'b2b-components/theme/components/Icon';
import { ExternalLink } from 'b2b-apps/shop/common/components/ExternalLink';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { isExternalUrl } from 'b2b-apps/shop/routes/utils/url';
import { Asset } from '../../NewsroomAssets/NewsroomAssets/Asset';
import { ComponentType, Props } from './';
import './NewsroomFooter.scss';

const NewsroomFooter: ComponentType = ({
  className,
  filesAssets,
  linksAssets,
}: Props): ReactElement | null => {
  const t = useTranslate();

  if (!filesAssets.length && !linksAssets.length) {
    return null;
  }

  const text = {
    pressReleaseAssets: t('PRESS RELEASE ASSETS'),
    links: t('Links: '),
  };

  const rootClassName = classNames(
    'cds-cms-NewsroomFooter',
    className,
  );

  return (
    <div className={rootClassName}>
      {filesAssets.length > 0 && (
        <div className="cds-cms-NewsroomFooter-Files">
          <h4 className="cds-cms-NewsroomFooter-TitleFiles">{text.pressReleaseAssets}</h4>
          <div className="row">
            {filesAssets.map((file: Record<string, any>, index: number) => file.isLoaded && file.data.asset && (
              <Asset
                className="col-lg-3 col-md-4 col-sm-6 col-xs-12"
                key={index}
                fileName={file.data.asset.filename}
                thumbnail={file.data.asset.url}
                url={file.data.asset.url}
              />
            ))}
          </div>
        </div>
      )}
      {linksAssets.length > 0 && (
        <div className="cds-cms-NewsroomFooter-Links">
          <div className="row">
            <h4 className="cds-cms-NewsroomFooter-TitleLinks">{text.links}</h4>
            <ul className="cds-List cds-List--Bulleted cds-cms-NewsroomFooter-LinksList">
            {linksAssets.map(
              (link: any, index) => link.data && (
                <li key={index}>
                {isExternalUrl(link.data.url)
                  ? <ExternalLink
                        className="cds-cms-NewsroomFooter-Link"
                        url={link.data.url}
                        label={link.data.label}
                      />
                  : <a
                      className="cds-Link cds-cms-NewsroomFooter-Link"
                      title={link.data.title}
                      href={link.data.url}
                    >
                      {link.data.label}
                      {isExternalUrl(link.data.url) && <Icon name={ICON_NAME.arrowLeft} size={ICON_SIZE.small} />}
                    </a>
                  }
                </li>
              ),
            )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export { NewsroomFooter };
